module.exports = __webpack_public_path__ + "media/components/country-flag/static/gu-b8f738e05d538a697d90ebcf3945e1f7.svg";